import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, PROCESS } from "../data/site";
import { Reveal } from "../components/Reveal";
import { PageHero, SectionLabel, ContactCTA } from "../components/Shared";

export default function Serveis() {
  useEffect(() => {
    document.title = "Serveis — Orbis Forum Català";
  }, []);

  return (
    <div>
      <PageHero
        label="Serveis"
        title="Consultoria especialitzada per a projectes internacionals"
        subtitle="Vuit àrees d'especialització dissenyades per acompanyar els ciutadans i les empreses de Catalunya en el seu desenvolupament global."
      />

      <section className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 2) * 0.08}>
                <Link
                  to={`/serveis/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group flex bg-ofc-black hover:bg-ofc-navy transition-colors duration-500 h-full"
                >
                  <div className="hidden sm:block w-40 shrink-0 overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="w-full h-full object-cover object-top opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
                    />
                  </div>
                  <div className="flex flex-col justify-between p-8 md:p-10 flex-1">
                    <div>
                      <span className="text-xs text-ofc-gold/70 tracking-widest">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <h3 className="font-serif-display text-2xl md:text-3xl mt-3 leading-tight group-hover:text-ofc-gold transition-colors">
                        {s.title}
                      </h3>
                      <p className="mt-4 text-sm text-white/50 font-light leading-relaxed">{s.short}</p>
                    </div>
                    <span className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/50 group-hover:text-ofc-gold transition-colors">
                      Explorar servei
                      <ArrowUpRight size={16} strokeWidth={1.5} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="border-t border-white/5 bg-ofc-navy/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <Reveal>
            <SectionLabel>Com treballem</SectionLabel>
            <h2 className="font-serif-display font-light text-3xl md:text-5xl tracking-tight mt-6 max-w-2xl">
              Un procés comú per a tots els serveis
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
            {PROCESS.map((p, i) => (
              <Reveal key={p.step} delay={i * 0.08}>
                <span className="font-serif-display text-4xl text-ofc-gold/70">{p.step}</span>
                <h3 className="font-serif-display text-xl mt-4">{p.title}</h3>
                <p className="mt-3 text-sm text-white/50 font-light leading-relaxed">{p.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </div>
  );
}
